import axios from "axios"
import { NotificationBody } from "../interfaces/service.interface"

class NotificationService {
  private api: any

  constructor() {
    this.api = axios.create({
      baseURL: `${process.env.NEXT_PUBLIC_API_URL}/notification/`,
    })
  }

  public sendNotification(mail: NotificationBody) {
    return this.api.post("send/", mail)
  }
}

const notificationService = new NotificationService()

export default notificationService
